export default function() {
	return 'rid' + (Math.random()*1e15).toFixed(0);
};



// WEBPACK FOOTER //
// ./src/random_id.js